import React, { Fragment } from 'react';
import SadminLogView from './SadminLogView';

const SadminLog = () => {
    return (
        <Fragment>
            <SadminLogView />
        </Fragment>
    );
};

export default SadminLog;
